import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
    SetInfoLand = '[FORM-INFO_ACT] SET_LAND',
    SetInfoCondo = '[FORM-INFO_ACT] SET_CONDO',
    SetInfoBuilding = '[FORM-INFO_ACT] SET_BUILDING',
    SetUpload = '[FORM-INFO_ACT] SET_UPLOAD',
    ResetStore = '[FORM-INFO_ACT] SET_RESETSTORE',
}

export const SetInfoLand = createAction(
    ActionTypes.SetInfoLand, //action name
    props<{ landData: any }>() //parameter
);

export const SetInfoCondo = createAction(
    ActionTypes.SetInfoCondo, //action name
    props<{ condoData: any }>() //parameter
);

export const SetInfoBuilding = createAction(
    ActionTypes.SetInfoBuilding, //action name
    props<{ buildingData: any }>() //parameter
);

export const SetUpload = createAction(
    ActionTypes.SetUpload, //action name
    props<{ upload: any }>()
);

export const ResetStore = createAction(
    ActionTypes.ResetStore //action name
);
